<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>收益明细</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <div class="dropdownTitle">
                <div class="titleTop">
                    <p class="currTitle">收益明细</p>
                    <el-button @click="HnadleMyApplyWithdrawal">提现</el-button>
                </div>
                <div  class="bookingItems">
                    <div>
                        <p>10</p>
                        <span>累计收益</span>
                    </div>
                    <div>
                        <p>10</p>
                        <span>可用余额</span>
                    </div>
                    
                </div>
            </div>
            <!-- <div class="profitItem"  v-show="vsData != ''"> -->
            <div class="profitItem" >
                <div class="item">
                    <p>团长奖励</p>
                    <span>未完成</span>
                </div>
                <div class="itmeIndex">
                    <div>
                        <p>订单：2023061722191708871006365</p>
                        <p>时间：2023-06-17 22:19:43</p>
                    </div>
                    <div>
                        <p>预计分配<span>+10</span></p>
                    </div>
                </div>
            </div>
            
            
            <!-- <div v-show="vsData == ''" class="teamsNull">
                <p>亲，未找到记录~</p>
            </div>
            -->
            
            <div style="text-align: right;">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="10"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            vsData: [],
            total: 0,
            hideOnSinglePage: true,
            widthNew: false
        
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listByUser(data){
            this.$store.dispatch('personal/myApplyToCash',data)
            .then(res => {
                if(res.ok){
                    this.total = res.data.total

                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                    this.vsData = res.data.items
                   
                }
            })
        },
       
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listSign = {
                vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
                vsfrom: 'app',
                mallToken: '',
                pageNo: val,
                pageSize: '10'
    
            }
            this.listByUser(listSign)
        },
        HnadleMyApplyWithdrawal(){
            this.$router.push({
                path: '/myApplyWithdrawal'
            })
        }
        // handlePersonal(){
        //     // this.$router.go(-1);
        //     this.$router.push({
        //         path: '/personal'
        //     })
        // }
    
    },
    mounted(){
        
       
    },
    created(){
        localStorage.setItem('active','1')
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let listFav = {
            vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
            vsfrom: 'app',
            mallToken: '',
            pageNo: '1',
            pageSize: '10'
        }
        // this.listByUser(listFav)
    }
}
</script>

<style scoped lang="scss">
@import url(../../css/personal.css);

.dropdownTitle{
    border-bottom: 0.5px solid #f2f2f2;
    padding:  0 10px 0px 0;
    .titleTop{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .currTitle{
            border: none;
        }
        .el-button{
            border-radius: 50px;
        }
    }
    .bookingItems{
        margin: 10px 0 10px 0;
        padding: 10px 10px 25px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        /* border-bottom: 0.5px solid #f2f2f2; */
        div{
            width: 50%;
            text-align: center;
        }
        p{
            font-size: 26px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        span{
            font-size: 16px;
            color: #888888;
            line-height: 30px;
        }
    }

}
.profitItem{
    margin-top: 20px;
    padding: 0 10px 20px 10px;
    border-bottom: 0.5px solid #f2f2f2;
    .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        span{
            color: tomato;
        }
    }
    .itmeIndex{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        p{
            font-size: 16px;
            color: #888888;
        }
        span{
            font-size: 22px;
            font-weight: 600;
            color: #000000;
            margin-left: 10px;
        }
    }
}

.teamsNull{
    text-align: center;
    margin-top: 20px;
}
</style>